import React from 'react';
import styled from 'styled-components';
import { translation } from '../../../../../translation/translation';
import { saasModernTheme } from 'common/theme/saasModern';
 
export const StyledButton = styled.button`
  border-radius: 12px;
  border: none;
  background: ${saasModernTheme.defaultBackgroundColor};
  color: white;
  padding: 10px 20px;
  font-family: ${saasModernTheme.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    background: ${saasModernTheme.customColor.gradiantColor};
  }
`;

const BtnGetStarted = ({ label, locale, link }) => {
  const displayMessage = () => {
    if (label) {
      return label;
    }
    if (locale && !label) {
      return translation.getStared[locale];
    }
    return 'Get started';
  };

  return (
    <StyledButton
      onClick={() =>
        (window.location.href = link || 'https://www.app.swiftask.ai/')
      }
    >
      {displayMessage()}
    </StyledButton>
  );
};

export default BtnGetStarted;
